import {Col, Divider, Empty, List, Modal, Popconfirm, Popover, Row, Skeleton, Spin, Tag, Typography} from 'antd';
import React, {useEffect, useState} from "react";
import {withRouter} from 'react-router';

import Link from 'antd/es/typography/Link';
import {connect} from "react-redux";
import {deleteArtistExhibition, getAllArtistExhibitions} from '../../api/artistExhibition';
import samplePicture from '../../asset/image/8757088.jpg';
import GalleryTablePanel from "../../component/GalleryTablePanel";
import {URL_EDIT_EXHIBITIONS_ID, URL_NEW_EXHIBITIONS} from '../../const';
import {getEditUrl} from "../../component/Utils";
import {getArtwork, getArtworkAdmin, getArtworkById} from "../../api/artworks";
import {FileExcelOutlined, FilePdfOutlined, QrcodeOutlined} from "@ant-design/icons";
import ViewExhibitionDrawer from "../../component/exhibition/ViewExhibitionDrawer";
import ExportInventoryReport from "../../component/exhibition/ExportInventoryReport";
import ExportExcelColumnsSelect from "../../component/base/selects/ExportExcelColumnsSelect";
import {artworkAllColumns, artworkColumns} from "../../component/piece/ArtworkColumns";
import HttpError from "../../component/base/HttpError";
import {is_admin_user} from "../../app/role";
import ExportInventoryQRCode from "../../component/exhibition/ExportInventoryQRCode";

const {Title, Text} = Typography

function sanityInput(text, default_length = 0) {
    if (!text) {
        return "        "
    }
    return text
}

function ExhibitionListView(props) {
    const [data, setData] = useState([])
    const [thumbnails, setThumbnails] = useState({})
    const [deleteConfirmShow, setDeleteConfirmShow] = useState(false)
    const [actionLoading, setActionLoading] = useState('')
    const [exportPopoverVisible, setExportPopoverVisible] = useState({})
    useEffect(() => {
        setData(props.data)
    }, [props])

    const deleteData = (id) => {
        props.deleteFunc(id)
    }

    const requestFunc = is_admin_user(props) ? getArtworkAdmin : getArtwork

    function exportActionListLayout(element) {
        const data = []
        data.push({
            text: 'Export to Excel',
            icon: <FileExcelOutlined/>,
            onClick: async () => {
                exportPopoverVisible[element.id] = false
                setExportPopoverVisible({...exportPopoverVisible})
                setActionLoading('Export to Excel')
                try {
                    let artistIds = (element.artist ? element.artist : element.artist_ids).toString().split(",")
                    const promises = []
                    artistIds.forEach((artistId) => {
                        promises.push(
                            requestFunc(1, 100000, null, null, artistId, {exhibitionFilter: element.id})
                        )
                    })
                    if (promises.length < 1) return;
                    let results = await Promise.all(promises)
                    let finalResults = []
                    results.forEach((result) => {
                        finalResults = finalResults.concat(result.data.results)
                    })
                    props.onExport(element, finalResults)
                } catch (e) {
                    HttpError(e)
                } finally {
                    setActionLoading('')
                }
            }
        })

        data.push({
            text: 'Export to Inventory Report', icon: <FilePdfOutlined/>, onClick: async () => {
                exportPopoverVisible[element.id] = false
                setExportPopoverVisible({...exportPopoverVisible})
                setActionLoading('Export to Inventory Report')
                try {
                    let artistIds = (element.artist ? element.artist : element.artist_ids).toString().split(",")
                    const promises = []
                    artistIds.forEach((artistId) => {
                        promises.push(
                            requestFunc(1, 100000, null, null, artistId, {exhibitionFilter: element.id})
                        )
                    })
                    if (promises.length < 1) return;
                    let results = await Promise.all(promises)
                    ExportInventoryReport(
                        artistIds,
                        props.email,
                        props.role,
                        results.map((res) => (res.data.results)),
                        [],
                        element
                    )
                } catch (e) {
                    HttpError(e)
                } finally {
                    setActionLoading('')
                }
            }
        })

        data.push({
            text: 'Export to QR Code', icon: <QrcodeOutlined/>, onClick: async () => {
                exportPopoverVisible[element.id] = false
                setExportPopoverVisible({...exportPopoverVisible})
                setActionLoading('Export to Inventory Report')
                try {
                    let artistIds = (element.artist ? element.artist : element.artist_ids).toString().split(",")
                    const promises = []
                    artistIds.forEach((artistId) => {
                        promises.push(
                            requestFunc(1, 100000, null, null, artistId, {exhibitionFilter: element.id})
                        )
                    })
                    if (promises.length < 1) return;
                    let results = await Promise.all(promises)
                    ExportInventoryQRCode(
                        artistIds,
                        props.email,
                        props.role,
                        results.map((res) => (res.data.results)),
                        [],
                        element
                    )
                } catch (e) {
                    HttpError(e)
                } finally {
                    setActionLoading('')
                }
            }
        })

        return (
            <List
                bordered
                dataSource={data}
                renderItem={(item, index) => (
                    <List.Item key={index}>
                        <Spin spinning={actionLoading === item.text} size={"small"}>
                              <span onClick={item.onClick} style={{fontSize: 14, cursor: 'pointer'}}>
                                {item.icon}&nbsp;{item.text}
                              </span>
                        </Spin>
                    </List.Item>
                )}
            />
        )
    }

    const getThumbnails = (element) => {
        const style = {
            width: '100%',
            maxWidth: 300,
            margin: '5px 0px 5px 0px',
            marginLeft: 'auto',
            marginRight: 'auto',
            borderRadius: 4
        }
        if (thumbnails[element.id]?.loading) {
            return <Skeleton style={style}/>
        }
        if (!thumbnails[element.id]?.url) {
            return <img style={style} src={samplePicture}
                        alt='Exhibition'/>
        }
        return (
            <img style={style} src={thumbnails[element.id]?.url}
                 alt='Exhibition'/>
        )
    }

    const items = []
    data?.forEach((element, index) => {
        let artworks = element['artwork_ids'] ? element['artwork_ids'].split(',') : []
        let artLength = artworks.length
        let addr1 = ''
        let addr2 = ''
        if (element['location']) {
            addr1 += element['location']
        }

        if (artLength > 0 && !thumbnails[element.id]) {
            thumbnails[element.id] = {loading: true}
            getArtworkById(artworks[0], null).then((res) => {
                thumbnails[element.id] = {loading: false, url: res.data.static_url}
            }).catch((e) => {

            }).finally(() => {
                thumbnails[element.id].loading = false
                setThumbnails({...thumbnails})
            })
        }

        // create
        items.push(
            <div key={'exhibition_' + element.id} style={{marginTop: 5}}>
                <Row style={{marginBottom: 15}} gutter={[12, 12]}>
                    <Col xs={24} sm={6} lg={6}
                         style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                        <Title level={5} style={{
                            marginTop: '5px',
                            marginLeft: "auto",
                            marginRight: 'auto'
                        }}>{element?.name?.toString().toUpperCase()}</Title>
                        {getThumbnails(element)}
                        <Typography style={{
                            paddingTop: 2,
                            fontSize: 10,
                            marginLeft: "auto",
                            marginRight: 'auto'
                        }}>Total {artLength} artworks</Typography>
                    </Col>
                    <Col xs={24} sm={12} lg={12} style={{display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
                        <div style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12
                        }}>
                            <Title level={5}
                                   style={{marginTop: '5px', marginLeft: "auto", marginRight: 'auto'}}>&nbsp;</Title>
                            <Typography style={{
                                width: 320,
                                marginTop: 12
                            }}><Tag>{sanityInput(element.type).replace("-", " ").toUpperCase()}</Tag></Typography>
                            <Typography
                                style={{width: 320}}>Date: {sanityInput(element.start_date) + ' - ' + sanityInput(element.end_date)}</Typography>
                            <Typography style={{width: 320}}>Location: {sanityInput(addr1)}</Typography>
                        </div>
                    </Col>
                    <Col xs={24} sm={6} lg={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
                        <Title level={5}
                               style={{marginTop: '5px', marginLeft: "auto", marginRight: 'auto'}}>&nbsp;</Title>
                        <div style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12
                        }}>

                            <Link key={'edit_' + element.id}
                                  style={{textDecoration: 'underline', height: 40, width: 320}}
                                  href={getEditUrl(URL_EDIT_EXHIBITIONS_ID, element.id)} target='_self'
                                  rel='noopener noreferrer'
                            >
                                {'Edit'}
                            </Link>
                            {element.has_artwork_exhibition && element.artwork_page_url && (
                                <Link key={'view_page_' + element.id}
                                      style={{textDecoration: 'underline', height: 40, width: 320}}
                                      href={element.artwork_page_url} target='_self'
                                      rel='noopener noreferrer'
                                >
                                    {'View Page'}
                                </Link>
                            )}
                            {/*<Link key={'open_' + element.id} style={{textDecoration: 'underline', height: 40}}*/}
                            {/*      onClick={()=>{props.onView(element)}} rel='noopener noreferrer'*/}
                            {/*>*/}
                            {/*    {'View'}*/}
                            {/*</Link>*/}
                            {artLength > 0 && (
                                <Popover
                                    open={!!exportPopoverVisible[element.id]}
                                    placement='bottomLeft'
                                    onOpenChange={(visible) => {
                                        exportPopoverVisible[element.id] = visible
                                        setExportPopoverVisible({...exportPopoverVisible})
                                    }}
                                    title=''
                                    content={exportActionListLayout(element)}
                                    trigger='click'
                                >
                                    <Link key={'export_' + element.id} style={{textDecoration: 'underline', height: 40}}
                                    >
                                        {'Export'}
                                    </Link>
                                </Popover>
                            )}
                            <Popconfirm
                                key={'delete_' + element.id}
                                title='Are you sure you want to permanently delete it?'
                                onConfirm={() => deleteData(element.id)}
                                onCancel={() => {
                                    setDeleteConfirmShow(false)
                                }}
                            >
                                <Link style={{textDecoration: 'underline', height: 40, color: 'red'}}>
                                    <Text style={{color: 'red'}}
                                          onClick={() => {
                                              setDeleteConfirmShow(true)
                                          }}
                                    >{'Delete'}</Text>
                                </Link>
                            </Popconfirm>
                        </div>
                    </Col>
                </Row>
                <Divider style={{marginBottom: 12, marginTop: 12}}/>
            </div>
        )
    })

    if (items.length === 0) {
        return <Empty/>
    }

    return (
        <div>{items}</div>
    )
}

@connect((state) => ({
        artistId: state.user.info.artistId,
        role: state.user.info.role,
        artists: state.artist.artists,
        email: state.artist.email
    }),
    {})
class Exhibition extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            exhibitions: [],
            viewExhibition: null,
            exportData: {raw: [], name: '', visible: false}
        }
        this.columns = [
            {"title": "id", "dataIndex": "id", "key": "id"},
            {"title": "name", "dataIndex": "name", "key": "name"},
            {"title": "type", "dataIndex": "type", "key": "type"},
            {"title": "location", "dataIndex": "location", "key": "location"},
            {"title": "street", "dataIndex": "street", "key": "street"},
            {"title": "state", "dataIndex": "state", "key": "state"},
            {"title": "start_date", "dataIndex": "start_date", "key": "start_date"},
            {"title": "end_date", "dataIndex": "end_date", "key": "end_date"},
            {"title": "open_reception_date", "dataIndex": "open_reception_date", "key": "open_reception_date"},
            {"title": "delivery_date", "dataIndex": "delivery_date", "key": "delivery_date"},
            {
                "title": "installation_begin_date",
                "dataIndex": "installation_begin_date",
                "key": "installation_begin_date"
            },
            {"title": "installation_end_date", "dataIndex": "installation_end_date", "key": "installation_end_date"},

            {
                "title": "de_installation_begin_date",
                "dataIndex": "de_installation_begin_date",
                "key": "de_installation_begin_date"
            },
            {
                "title": "de_installation_end_date",
                "dataIndex": "de_installation_end_date",
                "key": "de_installation_end_date"
            },
            {"title": "pick_up_art_date", "dataIndex": "pick_up_art_date", "key": "pick_up_art_date"},
            {"title": "curator", "dataIndex": "curator", "key": "curator"},
            {"title": "website", "dataIndex": "website", "key": "website"},
            {"title": "exhibition_description", "dataIndex": "exhibition_description", "key": "exhibition_description"},
            {"title": "artwork_ids", "dataIndex": "artwork_ids", "key": "artwork_ids"},
        ]
    }

    requestData = (pageId, pageSize, sort, filters, search, cancelToken) => {
        return new Promise((resolve, reject) => {
            getAllArtistExhibitions(pageId, pageSize, sort, filters, search, this.props.artistId, cancelToken).then((response) => {
                const apiData = {
                    data: response.data
                }
                this.setState({exhibitions: response.data.results})
                resolve(apiData);
            }).catch((error) => {
                reject(error)
            })
        });
    }

    deleteData = (id) => {
        // call api to delete by id
        return new Promise((resolve, reject) => {
            resolve(deleteArtistExhibition(id));
        });
    }

    render() {
        return (
            <div>
                <ViewExhibitionDrawer open={this.state.viewExhibition} onClose={() => {
                    this.setState({
                        viewExhibition: null
                    })
                }} element={this.state.viewExhibition}/>
                <Modal
                    destroyOnClose={true}
                    visible={this.state.exportData?.visible}
                    title='Export to Excel'
                    onCancel={() => {
                        this.state.exportData.visible = false
                        this.setState({
                            exportData: {...this.state.exportData}
                        })
                    }}
                    footer={null}
                >
                    <ExportExcelColumnsSelect
                        allColumns={artworkAllColumns}
                        columns={artworkColumns}
                        rawData={this.state.exportData?.raw ?? []}
                        fileName={this.state.exportData?.name ?? ''}/>
                </Modal>
                <GalleryTablePanel
                    requestData={this.requestData}
                    name={'exhibition'}
                    deleteData={this.deleteData}
                    viewOptions={['table', 'calendar']}
                    tableView={(props) => {
                        return <ExhibitionListView {...props} onView={(element) => {
                            this.setState({viewExhibition: element})
                        }}
                                                   onExport={(element, data) => {
                                                       this.setState({
                                                           exportData: {
                                                               raw: data,
                                                               name: "Exhibition_" + element.name,
                                                               visible: true
                                                           }
                                                       })
                                                   }}
                                                   role={this.props.role} artistId={this.props.artistId}
                                                   email={this.props.email}/>
                    }}
                    columns={this.columns}
                    disableExport={true}
                    addNewUrl={URL_NEW_EXHIBITIONS}/>
            </div>
        )
    }
}

export default withRouter(Exhibition)